/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolCategoryIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-category"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M6.88 9.78L10.97 3.1Q11.18 2.77 11.47 2.63Q11.78 2.48 12.1 2.48Q12.43 2.48 12.72 2.63Q13.03 2.77 13.22 3.1L17.32 9.78Q17.52 10.13 17.52 10.47Q17.52 10.82 17.35 11.13Q17.18 11.43 16.88 11.61Q16.57 11.8 16.18 11.8L8.03 11.8Q7.63 11.8 7.33 11.61Q7.03 11.43 6.85 11.13Q6.67 10.82 6.67 10.47Q6.67 10.13 6.88 9.78ZM17.7 23.1Q15.57 23.1 14.11 21.59Q12.65 20.07 12.65 17.95Q12.65 15.82 14.11 14.36Q15.57 12.9 17.7 12.9Q19.82 12.9 21.34 14.36Q22.85 15.82 22.85 17.95Q22.85 20.1 21.35 21.6Q19.85 23.1 17.7 23.1ZM2.45 21.18L2.45 14.72Q2.45 14.18 2.84 13.79Q3.23 13.4 3.77 13.4L10.22 13.4Q10.78 13.4 11.16 13.79Q11.55 14.18 11.55 14.72L11.55 21.18Q11.55 21.73 11.16 22.11Q10.78 22.5 10.22 22.5L3.77 22.5Q3.23 22.5 2.84 22.11Q2.45 21.73 2.45 21.18Z" fill={color} />
    </svg>
  );
}
